export default __webpack_public_path__ + "static/media/Arrow_Order_Up.abc08bcb.svg";